const DEVICE_ID_KEY = "pc_device_identifier";
const DEVICE_ID_DB = "pc_device_db";
const DEVICE_ID_STORE = "ids";
const DEVICE_ID_FIELD = "device_id";

function generateUUID(): string {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return (crypto as any).randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function openDb(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DEVICE_ID_DB, 1);
        req.onupgradeneeded = () => {
            req.result.createObjectStore(DEVICE_ID_STORE);
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

async function readFromIndexedDb(): Promise<string | null> {
    try {
        const db = await openDb();
        return new Promise(resolve => {
            const tx = db.transaction(DEVICE_ID_STORE, "readonly");
            const store = tx.objectStore(DEVICE_ID_STORE);
            const req = store.get(DEVICE_ID_FIELD);
            req.onsuccess = () => resolve(req.result ?? null);
            req.onerror = () => resolve(null);
        });
    } catch {
        return null;
    }
}

async function writeToIndexedDb(id: string) {
    try {
        const db = await openDb();
        const tx = db.transaction(DEVICE_ID_STORE, "readwrite");
        tx.objectStore(DEVICE_ID_STORE).put(id, DEVICE_ID_FIELD);
    } catch (e) {
        //console.error("writeToIndexedDb", e);
    }
}

export async function getOrCreateDeviceIdentifier(): Promise<string> {
    let id = await readFromIndexedDb();
    if (id) {
        localStorage.setItem(DEVICE_ID_KEY, id);
        return id;
    }

    id = localStorage.getItem(DEVICE_ID_KEY);
    if (id) {
        await writeToIndexedDb(id);
        return id;
    }

    id = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
    await writeToIndexedDb(id);

    try {
        if (navigator.storage?.persist) {
            await navigator.storage.persist();
        }
    } catch (e) {
        //console.error("getOrCreateDeviceIdentifier", e);
    }

    return id;
}
